import { CSSProperties } from 'react';

import { GalleryJustify } from './enums';
import { GalleryDisplayOptions } from '../../components/Gallery';
import { StoryDisplay } from '../../enums';

export const galleryJustifyContentMap: Record<
  GalleryJustify,
  CSSProperties['justifyContent']
> = {
  [GalleryJustify.Left]: 'left',
  [GalleryJustify.Center]: 'center',
  [GalleryJustify.Right]: 'right',
  [GalleryJustify.Evenly]: 'space-evenly',
};

export const GALLERY_DEFAULT_JUSTIFY: GalleryDisplayOptions['justify'] =
  GalleryJustify.Left;

export const GALLERY_DEFAULT_GAP: Record<
  StoryDisplay,
  GalleryDisplayOptions['gap']
> = {
  [StoryDisplay.Round]: 0,
  [StoryDisplay.Square]: '6vh',
} as const;
